import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Lock, CheckCircle2, ArrowRight, CreditCard } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
const US_STATES = [{
  code: 'AL'
}, {
  code: 'AK'
}, {
  code: 'AZ'
}, {
  code: 'AR'
}, {
  code: 'CA'
}, {
  code: 'CO'
}, {
  code: 'CT'
}, {
  code: 'DE'
}, {
  code: 'DC'
}, {
  code: 'FL'
}, {
  code: 'GA'
}, {
  code: 'HI'
}, {
  code: 'ID'
}, {
  code: 'IL'
}, {
  code: 'IN'
}, {
  code: 'IA'
}, {
  code: 'KS'
}, {
  code: 'KY'
}, {
  code: 'LA'
}, {
  code: 'ME'
}, {
  code: 'MD'
}, {
  code: 'MA'
}, {
  code: 'MI'
}, {
  code: 'MN'
}, {
  code: 'MS'
}, {
  code: 'MO'
}, {
  code: 'MT'
}, {
  code: 'NE'
}, {
  code: 'NV'
}, {
  code: 'NH'
}, {
  code: 'NJ'
}, {
  code: 'NM'
}, {
  code: 'NY'
}, {
  code: 'NC'
}, {
  code: 'ND'
}, {
  code: 'OH'
}, {
  code: 'OK'
}, {
  code: 'OR'
}, {
  code: 'PA'
}, {
  code: 'RI'
}, {
  code: 'SC'
}, {
  code: 'SD'
}, {
  code: 'TN'
}, {
  code: 'TX'
}, {
  code: 'UT'
}, {
  code: 'VT'
}, {
  code: 'VA'
}, {
  code: 'WA'
}, {
  code: 'WV'
}, {
  code: 'WI'
}, {
  code: 'WY'
}];
const COUNTRIES = ['Estados Unidos', 'México', 'Canadá', 'Argentina', 'Chile', 'Colombia', 'Perú', 'España', 'Ecuador', 'Guatemala', 'República Dominicana', 'Costa Rica', 'Panamá', 'Uruguay', 'Reino Unido', 'Australia', 'Otro país'];
export function CheckoutPage() {
  const navigate = useNavigate();
  const screenInit = useScreenInit();
  const [step, setStep] = useState<'checkout' | 'success'>(screenInit?.step === 'success' ? 'success' : 'checkout');
  const [isBumpAccepted, setIsBumpAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [country, setCountry] = useState('Estados Unidos');
  const isUS = country === 'Estados Unidos';
  // Sync with screenInit if it changes via orchestration
  useEffect(() => {
    if (screenInit?.step) {
      setStep(screenInit.step as 'checkout' | 'success');
    }
  }, [screenInit]);
  const basePrice = 65;
  const bumpPrice = 27;
  const baseShipping = 4.99;
  // El envío es gratis cuando el cliente acepta la suscripción (Club MINEvit)
  const shipping = isBumpAccepted ? 0 : baseShipping;
  const total = basePrice + shipping + (isBumpAccepted ? bumpPrice : 0);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setStep('success');
      window.scrollTo(0, 0);
    }, 1500);
  };
  if (step === 'success') {
    return <div className="min-h-screen bg-[#FCFAF8] flex items-center justify-center p-4 font-sans text-[#3E2723]" data-id="element-7">
        <div className="max-w-md w-full bg-white rounded-sm shadow-2xl p-10 text-center space-y-8 border border-[#F4EFEA]" data-id="element-8">
          <div className="w-24 h-24 bg-[#F4EFEA] rounded-full flex items-center justify-center mx-auto" data-id="element-9">
            <CheckCircle2 className="w-12 h-12 text-[#8B5A2B]" data-id="element-10" />
          </div>
          <div data-id="element-11">
            <h2 className="text-4xl font-serif text-[#2C1E16] mb-3" data-id="element-12">
              Pedido confirmado
            </h2>
            <p className="text-[#8C7A6B] font-light" data-id="element-13">
              Tu pedido de MINEvit está siendo procesado y se enviará en breve.
            </p>
          </div>
          <div className="bg-[#FCFAF8] p-6 rounded-sm text-left space-y-4 border border-[#E8DCC4]" data-id="element-14">
            <p className="text-xs text-[#8B5A2B] font-bold uppercase tracking-widest" data-id="element-15">
              Resumen del pedido
            </p>
            <div className="flex justify-between font-medium text-[#3E2723]" data-id="element-16">
              <span data-id="element-17">MINEvit Vitamina para el Cabello</span>
              <span data-id="element-18">$65.00</span>
            </div>
            {isBumpAccepted && <div className="flex justify-between font-medium text-[#8B5A2B]" data-id="element-19">
                <span data-id="element-20">Club MINEvit (1er Mes)</span>
                <span data-id="element-21">$27.00</span>
              </div>}
            <div className="flex justify-between font-medium text-[#3E2723]" data-id="element-22">
              <span data-id="element-23">Envío mundial</span>
              {isBumpAccepted ? <span className="text-[#8B5A2B] font-bold uppercase tracking-wide text-xs mt-0.5" data-id="element-24">
                  Gratis
                </span> : <span data-id="element-25">${shipping.toFixed(2)}</span>}
            </div>
            <div className="pt-4 border-t border-[#E8DCC4] flex justify-between font-serif text-xl font-bold text-[#2C1E16]" data-id="element-26">
              <span data-id="element-27">Total Pagado</span>
              <span data-id="element-28">${total.toFixed(2)}</span>
            </div>
            {isBumpAccepted && <p className="text-xs text-[#8C7A6B] italic leading-relaxed" data-id="element-29">
                Tu membresía Club MINEvit se renueva a $55/mes a partir del
                segundo mes. Cancela cuando quieras.
              </p>}
          </div>
          <button onClick={() => navigate('/')} className="w-full bg-[#2C1E16] text-white font-medium py-4 rounded-sm hover:bg-[#3E2723] transition-colors tracking-wide" data-id="element-30">
            Volver al Inicio
          </button>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-[#FCFAF8] pb-20 font-sans text-[#3E2723]" data-id="element-31">
      {/* Header */}
      <header className="bg-white border-b border-[#E8DCC4] py-5 px-4 sticky top-0 z-50" data-id="element-32">
        <div className="max-w-5xl mx-auto flex items-center justify-between" data-id="element-33">
          <div className="font-serif font-bold text-3xl tracking-tight text-[#2C1E16]" data-id="element-34">
            MINE<span className="text-[#8B5A2B] italic" data-id="element-35">vit</span>
          </div>
          <div className="flex items-center gap-2 text-sm font-medium text-[#8C7A6B] uppercase tracking-wider" data-id="element-36">
            <Lock className="w-4 h-4" data-id="element-37" /> Pago Seguro
          </div>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-12 gap-12" data-id="element-38">
        {/* Left Column: Form */}
        <div className="md:col-span-7 space-y-10" data-id="element-39">
          <form id="checkout-form" onSubmit={handleSubmit} className="space-y-10" data-id="element-40">
            {/* Contact Info */}
            <section className="bg-white p-8 rounded-sm shadow-sm border border-[#E8DCC4]" data-id="element-41">
              <h2 className="text-2xl font-serif text-[#2C1E16] mb-6 flex items-center gap-3" data-id="element-42">
                <span className="bg-[#F4EFEA] text-[#8B5A2B] w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold font-sans" data-id="element-43">
                  1
                </span>
                Información de contacto
              </h2>
              <div className="space-y-5" data-id="element-44">
                <div className="grid grid-cols-2 gap-5" data-id="element-45">
                  <div data-id="element-46">
                    <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-47">
                      Nombre
                    </label>
                    <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="María" data-id="element-48" />
                  </div>
                  <div data-id="element-49">
                    <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-50">
                      Apellido
                    </label>
                    <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="Pérez" data-id="element-51" />
                  </div>
                </div>
                <div data-id="element-52">
                  <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-53">
                    Correo Electrónico
                  </label>
                  <input required type="email" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="maria@ejemplo.com" data-id="element-54" />
                </div>
              </div>
            </section>

            {/* Shipping Info */}
            <section className="bg-white p-8 rounded-sm shadow-sm border border-[#E8DCC4]" data-id="element-55">
              <h2 className="text-2xl font-serif text-[#2C1E16] mb-6 flex items-center gap-3" data-id="element-56">
                <span className="bg-[#F4EFEA] text-[#8B5A2B] w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold font-sans" data-id="element-57">
                  2
                </span>
                Dirección de envío
              </h2>
              <div className="space-y-5" data-id="element-58">
                <div data-id="element-59">
                  <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-60">
                    País
                  </label>
                  <select required value={country} onChange={e => setCountry(e.target.value)} className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all appearance-none" data-id="element-61">
                    {COUNTRIES.map(c => <option key={c} value={c} data-id="element-62">
                        {c}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-63">
                  <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-64">
                    Dirección
                  </label>
                  <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="123 Main St" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-67">
                    Apartamento, suite, etc. (opcional)
                  </label>
                  <input type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="Apt 4B" data-id="element-68" />
                </div>
                <div className="grid grid-cols-2 gap-5" data-id="element-69">
                  <div data-id="element-70">
                    <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-71">
                      Ciudad
                    </label>
                    <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="New York" data-id="element-72" />
                  </div>
                  <div className="grid grid-cols-2 gap-3" data-id="element-73">
                    <div data-id="element-74">
                      <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-75">
                        {isUS ? 'Estado' : 'Estado / Provincia'}
                      </label>
                      {isUS ? <select required defaultValue="" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all appearance-none" data-id="element-76">
                          <option value="" disabled data-id="element-77">
                            Estado
                          </option>
                          {US_STATES.map(s => <option key={s.code} value={s.code} data-id="element-78">
                              {s.code}
                            </option>)}
                        </select> : <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="Estado / Provincia" data-id="element-79" />}
                    </div>
                    <div data-id="element-80">
                      <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-81">
                        {isUS ? 'ZIP code' : 'Código postal'}
                      </label>
                      <input required type="text" inputMode="numeric" pattern={isUS ? '\\d{5}(-\\d{4})?' : undefined} maxLength={isUS ? 10 : undefined} className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder={isUS ? '10001' : 'Código postal'} data-id="element-82" />
                    </div>
                  </div>
                </div>
                <p className="text-xs text-[#8C7A6B] flex items-center gap-1.5" data-id="element-83">
                  <ShieldCheck className="w-4 h-4 text-[#8B5A2B]" data-id="element-84" />
                  Enviamos a todo el mundo. Selecciona tu país para continuar.
                </p>
              </div>
            </section>

            {/* Payment Info */}
            <section className="bg-white p-8 rounded-sm shadow-sm border border-[#E8DCC4]" data-id="element-85">
              <h2 className="text-2xl font-serif text-[#2C1E16] mb-6 flex items-center gap-3" data-id="element-86">
                <span className="bg-[#F4EFEA] text-[#8B5A2B] w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold font-sans" data-id="element-87">
                  3
                </span>
                Método de pago
              </h2>
              <div className="space-y-5" data-id="element-88">
                <div className="relative" data-id="element-89">
                  <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-90">
                    Número de Tarjeta
                  </label>
                  <div className="relative" data-id="element-91">
                    <input required type="text" className="w-full pl-12 pr-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="0000 0000 0000 0000" data-id="element-92" />
                    <CreditCard className="w-5 h-5 text-[#8C7A6B] absolute left-4 top-3.5" data-id="element-93" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-5" data-id="element-94">
                  <div data-id="element-95">
                    <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-96">
                      Fecha de Vencimiento
                    </label>
                    <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="MM/AA" data-id="element-97" />
                  </div>
                  <div data-id="element-98">
                    <label className="block text-sm font-medium text-[#5C4033] mb-2" data-id="element-99">
                      CVC
                    </label>
                    <input required type="text" className="w-full px-4 py-3 bg-[#FCFAF8] border border-[#E8DCC4] rounded-sm focus:ring-1 focus:ring-[#8B5A2B] focus:border-[#8B5A2B] outline-none transition-all" placeholder="123" data-id="element-100" />
                  </div>
                </div>
              </div>
            </section>

            {/* Mobile Submit Button (Hidden on Desktop) */}
            <div className="md:hidden" data-id="element-101">
              <button type="submit" disabled={isSubmitting} className="w-full bg-[#8B5A2B] hover:bg-[#704822] text-white text-lg font-medium py-4 rounded-sm shadow-xl transition-all flex items-center justify-center gap-3 disabled:opacity-70 tracking-wide" data-id="element-102">
                {isSubmitting ? 'Procesando...' : `Completar Pedido - ${total.toFixed(2)}`}
                {!isSubmitting && <ArrowRight className="w-5 h-5" data-id="element-103" />}
              </button>
            </div>
          </form>
        </div>

        {/* Right Column: Order Summary & Bump */}
        <div className="md:col-span-5 space-y-8" data-id="element-104">
          {/* Order Summary */}
          <div className="bg-white p-8 rounded-sm shadow-sm border border-[#E8DCC4] sticky top-28" data-id="element-105">
            <h3 className="text-xl font-serif text-[#2C1E16] mb-6 pb-4 border-b border-[#F4EFEA]" data-id="element-106">
              Resumen del pedido
            </h3>

            <div className="flex items-start gap-5 mb-8" data-id="element-107">
              <div className="w-20 h-20 bg-[#F4EFEA] rounded-lg flex items-center justify-center shrink-0 overflow-hidden border border-[#E8DCC4]" data-id="element-108">
                <img src="https://cdn.magicpatterns.com/uploads/sqTcHRkXaSpBL7JGMnfsyD/minevit.webp" alt="MINEvit Premium Vitamins bottle" className="w-full h-full object-contain" data-id="element-109" />
              </div>
              <div className="flex-1 pt-1" data-id="element-110">
                <h4 className="font-medium text-[#3E2723] leading-tight mb-1" data-id="element-111">
                  MINEvit Vitamina para el Cabello
                </h4>
                <p className="text-sm text-[#8C7A6B] font-light" data-id="element-112">
                  Suministro para 1 Mes
                </p>
              </div>
              <div className="font-medium text-[#3E2723] pt-1" data-id="element-113">
                ${basePrice}
              </div>
            </div>

            {/* ORDER BUMP */}
            <div className={`border rounded-sm p-5 mb-8 transition-colors ${isBumpAccepted ? 'border-[#8B5A2B] bg-[#F4EFEA]' : 'border-[#E8DCC4] bg-[#FCFAF8]'}`} data-id="element-114">
              <div className="flex items-start gap-4" data-id="element-115">
                <div className="pt-1" data-id="element-116">
                  <input type="checkbox" id="bump" checked={isBumpAccepted} onChange={e => setIsBumpAccepted(e.target.checked)} className="w-5 h-5 text-[#8B5A2B] border-[#C4B5A5] rounded-sm focus:ring-[#8B5A2B] cursor-pointer" data-id="element-117" />
                </div>
                <div data-id="element-118">
                  <label htmlFor="bump" className="cursor-pointer" data-id="element-119">
                    <div className="flex items-center gap-2 mb-2" data-id="element-120">
                      <span className="bg-[#2C1E16] text-[#E8DCC4] text-[10px] font-bold px-2.5 py-1 rounded-sm uppercase tracking-widest" data-id="element-121">
                        Oferta Única
                      </span>
                    </div>
                    <h4 className="font-serif font-bold text-[#2C1E16] text-base leading-tight mb-2" data-id="element-122">
                      ¡Sí, agrega Club MINEvit a mi pedido!
                    </h4>
                    <p className="text-sm text-[#5C4033] leading-relaxed font-light" data-id="element-123">
                      Súmate ahora a nuestra Membresía Mensual y obtén tu primer
                      mes por solo{' '}
                      <span className="font-medium text-[#8B5A2B]" data-id="element-124">$27</span>{' '}
                      (normalmente $55){' '}
                      <span className="font-medium text-[#8B5A2B]" data-id="element-125">
                        + envío mundial GRATIS
                      </span>
                      . ¡Mantén tu regeneración celular sin interrupciones y
                      ahorra en cada pedido!
                    </p>
                    <p className="text-xs text-[#8C7A6B] leading-relaxed mt-2 italic" data-id="element-126">
                      Después del primer mes, tu membresía se renueva a $55/mes
                      a partir del segundo mes. Cancela cuando quieras.
                    </p>
                  </label>
                </div>
              </div>
            </div>

            {/* Totals */}
            <div className="space-y-3 text-sm font-medium text-[#5C4033] mb-8" data-id="element-127">
              <div className="flex justify-between" data-id="element-128">
                <span data-id="element-129">Subtotal</span>
                <span data-id="element-130">${basePrice}</span>
              </div>
              {isBumpAccepted && <div className="flex justify-between text-[#8B5A2B]" data-id="element-131">
                  <span data-id="element-132">Club MINEvit (1er Mes)</span>
                  <span data-id="element-133">+${bumpPrice}</span>
                </div>}
              <div className="flex justify-between" data-id="element-134">
                <span data-id="element-135">Envío mundial</span>
                {isBumpAccepted ? <span className="flex items-center gap-2" data-id="element-136">
                    <span className="text-[#8C7A6B] line-through" data-id="element-137">
                      ${baseShipping.toFixed(2)}
                    </span>
                    <span className="text-[#8B5A2B] font-bold uppercase tracking-wide text-xs" data-id="element-138">
                      Gratis
                    </span>
                  </span> : <span data-id="element-139">${baseShipping.toFixed(2)}</span>}
              </div>
              <div className="flex justify-between pt-5 border-t border-[#E8DCC4] text-xl font-serif font-bold text-[#2C1E16]" data-id="element-140">
                <span data-id="element-141">Total</span>
                <span data-id="element-142">${total.toFixed(2)}</span>
              </div>
              {isBumpAccepted && <p className="text-xs text-[#8C7A6B] italic pt-1 leading-relaxed" data-id="element-143">
                  Incluye el primer mes de Club MINEvit a $27. Se renueva a
                  $55/mes a partir del segundo mes. Cancela cuando quieras.
                </p>}
            </div>

            {/* Desktop Submit Button */}
            <button form="checkout-form" type="submit" disabled={isSubmitting} className="hidden md:flex w-full bg-[#8B5A2B] hover:bg-[#704822] text-white text-lg font-medium py-4 rounded-sm shadow-xl transition-all items-center justify-center gap-3 disabled:opacity-70 tracking-wide" data-id="element-144">
              {isSubmitting ? 'Procesando...' : `Completar Pedido - ${total.toFixed(2)}`}
              {!isSubmitting && <ArrowRight className="w-5 h-5" data-id="element-145" />}
            </button>

            {/* Trust Indicators */}
            <div className="mt-8 space-y-4" data-id="element-146">
              <div className="flex items-center gap-3 text-xs text-[#8C7A6B] justify-center font-medium tracking-wide uppercase" data-id="element-147">
                <Lock className="w-4 h-4 text-[#8B5A2B]" data-id="element-148" /> Pago Cifrado de 256
                Bits
              </div>
              <div className="flex items-center gap-3 text-xs text-[#8C7A6B] justify-center font-medium tracking-wide uppercase" data-id="element-149">
                <ShieldCheck className="w-4 h-4 text-[#8B5A2B]" data-id="element-150" /> Garantía de
                60 Días
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}